<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="71.376"
    height="41.526"
    viewBox="0 0 71.376 41.526"
  >
    <g transform="translate(-61.108 -9.422)">
      <path
        d="M-33.264-6.192h1.332V-7.248h-1.332V-9.912h-1.044v2.664h-1.476v1.056h1.476v3.6c-.6.252-1.152.468-1.584.612l.432,1.128c1.068-.48,2.436-1.1,3.7-1.716l-.252-.984c-.408.168-.84.348-1.248.528ZM-29.22-.3c-.768,0-.9-.132-.9-.8V-5.04l1.344-.576v3.864h1.044V-6.06l1.392-.6c0,1.824-.024,2.94-.072,3.18s-.156.288-.312.288c-.12,0-.444,0-.7-.012a3.446,3.446,0,0,1,.252.948,3.7,3.7,0,0,0,1.152-.132c.372-.1.576-.36.636-.864.072-.468.1-2.1.1-4.332l.048-.192-.78-.3-.192.156-.216.168-1.308.552v-2.856h-1.044v3.3l-1.344.564V-8.928h-1.056v3.18l-1.248.528.42.984.828-.348v3.468c0,1.44.42,1.812,1.9,1.812h2.748c1.308,0,1.644-.54,1.8-2.2a3.224,3.224,0,0,1-.984-.408C-25.812-.6-25.932-.3-26.592-.3Zm11.748-5.6a7.713,7.713,0,0,0-.876-2.16l-.876.3a7.825,7.825,0,0,1,.8,2.2Zm-2.064.2a7.744,7.744,0,0,0-1.08-2.016l-.828.348a8.845,8.845,0,0,1,1.008,2.076Zm3.48-2.016a10.322,10.322,0,0,1-2.2,3.528c-.792-.408-1.62-.792-2.376-1.092l-.612.756a23.313,23.313,0,0,1,2.232,1.068A10.729,10.729,0,0,1-21.7-1.8a6.176,6.176,0,0,1,.732.9,12.063,12.063,0,0,0,2.928-2,15.315,15.315,0,0,1,2.352,1.656L-15-2.124a14.776,14.776,0,0,0-2.292-1.548,12.5,12.5,0,0,0,2.3-3.768ZM-22.02-.7V-8.472h7.668V-.7ZM-23.136-9.54V.912h1.116V.372h7.668v.54h1.164V-9.54Zm16.452.132-1.4-.144a13.413,13.413,0,0,1-.276,2.58c-.684.06-1.332.108-1.716.12-.408.012-.756.024-1.164,0l.12,1.3c.336-.06.888-.132,1.188-.168.276-.036.768-.1,1.32-.156a19.044,19.044,0,0,1-2.5,5.844l1.236.492A25.056,25.056,0,0,0-7.392-6c.456-.048.852-.072,1.1-.072.756,0,1.224.18,1.224,1.212A9.753,9.753,0,0,1-5.6-1.344a.94.94,0,0,1-.984.576,6.249,6.249,0,0,1-1.464-.24L-7.86.24A6.748,6.748,0,0,0-6.432.408,1.766,1.766,0,0,0-4.584-.636,11.619,11.619,0,0,0-3.9-4.992c0-1.68-.876-2.148-2.04-2.148-.276,0-.708.024-1.2.072.108-.564.216-1.14.288-1.512C-6.8-8.844-6.744-9.156-6.684-9.408ZM-2.544-8.2l-1.116.48a14.322,14.322,0,0,1,2.076,4.44L-.4-3.828A20.783,20.783,0,0,0-2.544-8.2Zm6.612-1.32-.3,1.14c.924.24,3.564.792,4.74.948l.276-1.164A35.168,35.168,0,0,1,4.068-9.516ZM3.96-7.236,2.688-7.4a45.007,45.007,0,0,1-.612,4.932l1.1.264a2.442,2.442,0,0,1,.408-.636,4.5,4.5,0,0,1,3.54-1.524c1.152,0,1.98.636,1.98,1.524,0,1.584-1.872,2.58-5.58,2.112L3.888.5C8.58.9,10.4-.66,10.4-2.82c0-1.428-1.224-2.616-3.18-2.616A5.777,5.777,0,0,0,3.48-4.1C3.588-4.836,3.792-6.48,3.96-7.236Zm16.428-.936v1.944c0,.912.216,1.188,1.164,1.188H22.62c.72,0,.984-.3,1.092-1.5a2.9,2.9,0,0,1-.9-.372c-.024.864-.072.984-.3.984h-.8c-.264,0-.3-.036-.3-.312V-8.172ZM17.6-8.508h4.872v1.26h1V-9.456H16.656V-7.2H17.6Zm.888.36c-.072,1.44-.384,2.184-2.112,2.592a2.467,2.467,0,0,1,.552.8c2.052-.552,2.472-1.572,2.592-3.4Zm-2.268,3.1-1.092.324v-1.98h1.2V-7.74h-1.2v-2.316h-1.02V-7.74H12.72v1.032h1.392v2.28c-.588.168-1.128.324-1.56.432l.252,1.08c.4-.132.84-.264,1.308-.408V-.288c0,.168-.06.2-.216.2-.132.012-.576.012-1.056,0a3.562,3.562,0,0,1,.3,1.032,3.58,3.58,0,0,0,1.56-.2c.324-.18.432-.48.432-1.032V-3.636c.408-.132.828-.264,1.236-.4Zm7.32,2.124v-1H20.52V-5.172H19.428v1.248h-2.94v1h2.28A6.821,6.821,0,0,1,15.8-.36a4.443,4.443,0,0,1,.72.852,7.6,7.6,0,0,0,2.9-2.7V.936H20.52V-2.22a8.55,8.55,0,0,0,2.6,2.64,4.032,4.032,0,0,1,.756-.864,7.447,7.447,0,0,1-2.712-2.484Zm8.424-6.648h-1.38c.024.12.06.492.1.876.012.144.012.348.024.612-1.716.024-3.948.084-5.3.108l.036,1.152c1.488-.1,3.456-.168,5.28-.192,0,.348.012.708.012,1.02a2.4,2.4,0,0,0-.672-.084,2.167,2.167,0,0,0-2.232,2.16,2,2,0,0,0,2.016,2.088,1.88,1.88,0,0,0,.84-.18,4.611,4.611,0,0,1-3.1,1.764L28.608.756c2.844-.828,3.7-2.712,3.7-4.308a2.956,2.956,0,0,0-.42-1.6c0-.54,0-1.236-.012-1.884,1.74,0,2.88.024,3.588.06L35.484-8.1h-3.6c0-.24,0-.456.012-.6A6.993,6.993,0,0,1,31.968-9.576ZM28.956-3.948a1.081,1.081,0,0,1,1.092-1.128.989.989,0,0,1,.936.576c.156,1.128-.312,1.62-.936,1.62A1.053,1.053,0,0,1,28.956-3.948Z"
        transform="translate(97 50)"
        fill="currentColor"
      />
      <g transform="translate(96.735 21.014)">
        <g transform="translate(-12.735 -11.592)">
          <template v-if="active">
            <path
              d="M17.871,6,9.915,2,2,6V23.513l7.915-4,7.957,4,7.915-4V2Z"
              transform="translate(-1.158 -1.158)"
              fill="#ad393a"
            />
            <g>
              <path
                d="M17.871,6,9.915,2,2,6V23.513l7.915-4,7.957,4,7.915-4V2Z"
                transform="translate(-1.158 -1.158)"
                fill="none"
                stroke="#ad393a"
                stroke-linejoin="round"
                stroke-width="1.684"
              />
            </g>
            <path
              d="M22.8,21.224V7.5l6.273,3.157V24.382Z"
              transform="translate(-13.201 -4.343)"
              fill="#fff"
            />
            <path
              d="M22.484,6.936,27.031,9.21V21.082l-4.547-2.273ZM20.8,4.2V19.861l7.915,4V8.2Z"
              transform="translate(-12.043 -2.432)"
              fill="#fff"
            />
          </template>
          <template v-else>
            <path
              d="M17.871,6,9.915,2,2,6V23.513l7.915-4,7.957,4,7.915-4V2Z"
              transform="translate(-1.158 -1.158)"
              fill="#fff"
            />
            <g>
              <path
                d="M17.871,6,9.915,2,2,6V23.513l7.915-4,7.957,4,7.915-4V2Z"
                transform="translate(-1.158 -1.158)"
                fill="none"
                stroke="#999"
                stroke-linejoin="round"
                stroke-width="1.684"
              />
            </g>
            <path
              d="M20.8,42.9Z"
              transform="translate(-12.043 -24.839)"
              fill="#fff"
            />
            <g>
              <line
                y2="17.134"
                transform="translate(8.757 0.926)"
                fill="none"
                stroke="#999"
                stroke-linejoin="round"
                stroke-width="1.684"
              />
            </g>
            <path
              d="M39.7,28.792v0Z"
              transform="translate(-22.987 -6.774)"
              fill="#fff"
            />
            <g>
              <path
                d="M39.7,28.792V11.7"
                transform="translate(-22.987 -6.774)"
                fill="none"
                stroke="#999"
                stroke-linejoin="round"
                stroke-width="1.684"
              />
            </g>
          </template>
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts" src="./FooterMenuIconMap.ts"></script>
